import { formatteDate } from '../../../services/common'

const VerificationDate = ({ dateModified, contributor }) => {
    return (
        <p className="baseocom-verifcation-date-block">
            Vérifié le {formatteDate(dateModified)} - {contributor}
        </p>
    )
}
export default VerificationDate
